// src/stores/home.js
import { defineStore } from 'pinia'
import { httpRequest } from '@/services/api'
import { showAlert } from '@/composables/useAlert'

export const useHomeStore = defineStore('home', {
  state: () => ({
    recommended: [],
    agencyOffers: [],
    isLoading: false,
    agency: null,
    agencyCars: []
  }),

  actions: {
    async fetchHomeData() {
      this.isLoading = true
      try {
        const res = await httpRequest('/home', { method: 'GET' })
        this.recommended = res.data.today_offers || []
        this.agencyOffers = res.data.agency_offers || []
        console.log('Agency offers:', this.agencyOffers)
      } catch (error) {
        showAlert(error.response?.data?.message || 'حدث خطأ أثناء جلب البيانات', 'error')
      } finally {
        this.isLoading = false
      }
    },
    async fetchCarsByAgency(id) {
      this.isLoading = true
      this.agencyCars = []
      this.agency = null
      try {
        const res = await httpRequest(`/cars/get-by-agency/${id}`, { method: "GET" })
        this.agencyCars = res.data || []   // نخزن العربيات
        this.agency = this.agencyCars.length ? this.agencyCars[0].user : null
      } catch (error) {
        showAlert(error.response?.data?.message || "فشل تحميل بيانات الوكالة", "error")
      } finally {
        this.isLoading = false
      }
    }

  
  }
})
